export default __webpack_public_path__ + "static/logo-10ab68d2ba3b6095a7c9c0d4ce901428.png";